module.exports = __webpack_public_path__ + "style/img/jc2.46cbce5c.jpg";